import firedux from './firedux'
import store from './store'

import {watchUI, watchEmbeds} from './watchers'

import setPluginSettings from './setters/plugin_settings'

export function initDataForUI () {
  watchUI()

  window.stoore = store
}

export function initDataForEmbeds () {
  watchEmbeds()
}

export function initSettings (settings) {
  setPluginSettings(settings)
}

// Idempotent Signin
export function signInV2 (credentials) {
  const prevAuth = firedux.ref.getAuth()

  if (!prevAuth && credentials && credentials.token) {
    // sign in as user for first time
    console.log('[RCHAT-AUTH] signing in user for the first time', prevAuth, credentials, !prevAuth && credentials && credentials.token);
    return firedux.ref.authWithCustomToken(credentials.token)
  }

  if (!prevAuth && !credentials) {
    // sign in guest for the first time
    console.log('[RCHAT-AUTH] signing in guest for the first time', prevAuth, credentials, !prevAuth && !credentials);
    return firedux.ref.authAnonymously()
  }

  if (prevAuth && prevAuth.provider === 'custom' && !credentials) {
    // sign out and sign in as guest
    console.log('[RCHAT-AUTH] sign out and sign in as guest', prevAuth, credentials, prevAuth && prevAuth.provider === 'custom' && !credentials);
    firedux.ref.unauth()
    return firedux.ref.authAnonymously()
  }

  if (prevAuth && prevAuth.provider === 'anonymous' && !credentials) {
    // resolve silently - do nothing -
    console.log('[RCHAT-AUTH] take as existing guest', prevAuth, credentials, prevAuth && prevAuth.provider === 'anonymous' && !credentials);
    return Promise.resolve()
  }

  if (prevAuth && credentials && credentials.data && credentials.data.uid && credentials.data.uid !== prevAuth.uid) {
    // sign out and sign in as user
    console.log('[RCHAT-AUTH] sign out and sign in as user', prevAuth, credentials, prevAuth && credentials && credentials.data && credentials.data.token && credentials.data.uid !== prevAuth.uid);
    firedux.ref.unauth()
    return firedux.ref.authWithCustomToken(credentials.token)
  }

  if (prevAuth && credentials && credentials.data && credentials.data.uid === prevAuth.uid) {
    // resolve silently - do nothing -
    console.log('[RCHAT-AUTH] take as existing user', prevAuth, credentials, prevAuth && credentials && credentials.data && credentials.data.uid === prevAuth.uid);
    return Promise.resolve()
  }

  // give detailed error about what's wrong
  if (credentials && !credentials.token) {
    return Promise.reject('rchat sign in failed: No token is provided within credentials')
  }

  return Promise.reject('rchat sign in failed: unknown reason. Make sure you are providing credentials correctly.')
}

// DEPRECIATED: use signInV2 instead.
export function signIn (credentials) {
  if (!credentials) {
    return firedux.ref.authAnonymously()
  } else if (credentials.token) {
    return firedux.ref.authWithCustomToken(credentials.token)
  } else {
    return firedux.ref.authWithPassword(credentials)
  }
}

// DEPRECIATED: use signInV2 instead.
export function signOut () {
  return firedux.ref.unauth()
}

export function getAuth () {
  return firedux.ref.getAuth()
}

export function onAuth (cb) {
  return firedux.ref.onAuth(cb)
}



/** WEBPACK FOOTER **
 ** ./modules/shared/data/init.js
 **/